var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-section-skeleton",class:`home-section-skeleton--${_vm.variant}`,attrs:{"aria-hidden":"true"}},_vm._l((_vm.count),function(item){return _c('span',{key:item,staticClass:"home-section-skeleton__item"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }